import React from 'react';
import { useQueryClient } from 'react-query';

import closeIcon from 'images/directory/x_icon.svg';

import Pill from '@components/Pill';
import { useFollowUpdate } from '@hooks';
import { BasicEntity } from '@utils/backend-api/entities';
import { FollowAction, FollowType } from '@utils/backend-api/follow';
import { capitalize } from '@utils/formatting';

interface TopicTagProps {
  entity: BasicEntity;
  identityId: number | string;
}

const TopicTag = ({ entity, identityId }: TopicTagProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateFollow } = useFollowUpdate();

  const handleRemoveTopic = async () => {
    await updateFollow({
      followType: FollowType.Entity,
      followeeId: entity.id,
      followAction: FollowAction.Unfollow,
      identityId: identityId,
      queryClient,
    });
  };

  return (
    <Pill
      onClick={handleRemoveTopic}
      /* capitalize first letter of each word (can't use lodash's startCase because it removes special characters) */
      text={capitalize(entity.name)}
      icon={closeIcon}
    />
  );
};

export default TopicTag;
